const authenticate = (logged: boolean) => {
  try {
    const mainNavigation = document.querySelector(".main-navigation");

    if (!mainNavigation) {
      return;
    }

    const trCookie = document.cookie.match(
      new RegExp("(^| )" + "tr_sign-up" + "=([^;]+)")
    );

    if (trCookie) {
      document.body.classList.add("session-cookie");
    }

    if (logged) {
      mainNavigation.classList.remove("session-guest");
      mainNavigation.classList.add("session-user");
      document.body.classList.remove("session-guest");
      document.body.classList.add("session-user");
    } else {
      mainNavigation.classList.remove("session-user");
      mainNavigation.classList.add("session-guest");
      document.body.classList.remove("session-user");
      document.body.classList.add("session-guest");
    }
  } catch (e) {
    return;
  }
};

export const initSession = () => {
  const iframe = document.createElement("iframe");
  iframe.src = `${CONFIG.ssoHost}/session`;
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  window.addEventListener("message", event => {
    if (event.origin === CONFIG.ssoHost) {
      authenticate(event.data.loggedIn);
    }
  });
};
